import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import Avatar from 'components/ui/Avatar';

import BotApi from 'api/bot';
import Header from 'components/ui/Header';
import JobAddButton from 'components/bots/jobs/JobAddButton';

const BotHeader = ({ botId }) => {
  const { t } = useTranslation();
  const { data } = useQuery(['bot', botId], () => BotApi.get(botId));

  if (!data) {
    return null;
  }

  const sector = data.sectors[0] || {};

  return (
    <Header>
      <div className="d-flex justify-content-between">
        <div className="flex-fill">
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              <div className="me-3">
                <Link to="/bots">
                  <FiArrowLeft size={24} />
                </Link>
              </div>

              <div className="me-3 d-none d-md-block">
                <Avatar
                  name={data.name}
                  src={data.profile_image}
                  size={70}
                  sourceTTL={0}
                  className="shadow rounded text-secondary bg-white"
                  round="20px"
                />
              </div>

              <div>
                <div>
                  <small className="text-uppercase">
                    <Link to="/bots">bots</Link> / {sector.name || t('bots.categories.none')}
                  </small>
                </div>
                <h2 className="m-0 p-0 fw-lighter">{data.name}</h2>
              </div>
            </div>

            <div>
              <JobAddButton botId={data.id} enabled={data.enabled} />
            </div>
          </div>
        </div>
      </div>
    </Header>
  );
};

export default BotHeader;
